__turbopack_context__.v({
  "count": "fjXDCG_count",
  "item": "fjXDCG_item",
  "label": "fjXDCG_label",
  "nav": "fjXDCG_nav",
  "title": "fjXDCG_title",
});
